import React from 'react';
import { Tag, Plus, Trash2 } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';

export const DiscountsTab = ({ discounts, onNewDiscount, onToggle, onDelete }) => (
  <Card className="bg-purple-800/50 border-purple-600">
    <CardHeader className="flex flex-row items-center justify-between">
      <CardTitle className="text-white flex items-center gap-2">
        <Tag className="w-5 h-5" />
        Discount Codes
      </CardTitle>
      <Button
        onClick={onNewDiscount}
        className="bg-yellow-500 hover:bg-yellow-600 text-purple-900"
        data-testid="new-discount-btn"
      >
        <Plus className="w-4 h-4 mr-2" />
        New Code
      </Button>
    </CardHeader>
    <CardContent>
      {discounts.length > 0 ? (
        <div className="space-y-3">
          {discounts.map((discount) => (
            <div
              key={discount.code}
              className="flex flex-col md:flex-row md:items-center justify-between p-4 bg-purple-900/50 rounded-lg border border-purple-700 gap-4"
            >
              <div>
                <p className="text-white font-bold text-lg">{discount.code}</p>
                <p className="text-purple-300 text-sm">
                  {discount.discount_type === 'percentage'
                    ? `${discount.value}% off`
                    : `$${discount.value} off`}
                  {discount.min_order_amount > 0 && ` (min $${discount.min_order_amount})`}
                </p>
                <p className="text-purple-400 text-xs">
                  Used: {discount.current_uses || 0}
                  {discount.max_uses ? `/${discount.max_uses}` : ''}
                  {discount.expires_at &&
                    ` • Expires: ${new Date(discount.expires_at).toLocaleDateString()}`}
                </p>
              </div>
              <div className="flex items-center gap-2">
                <Badge className={discount.is_active ? 'bg-green-500' : 'bg-gray-500'}>
                  {discount.is_active ? 'Active' : 'Inactive'}
                </Badge>
                <Button
                  size="sm"
                  variant="outline"
                  onClick={() => onToggle(discount.code)}
                  className="border-purple-600 text-purple-200"
                >
                  {discount.is_active ? 'Disable' : 'Enable'}
                </Button>
                <Button
                  size="sm"
                  variant="destructive"
                  onClick={() => onDelete(discount.code)}
                  data-testid={`delete-discount-${discount.code}`}
                >
                  <Trash2 className="w-4 h-4" />
                </Button>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-purple-300 text-center py-8">No discount codes yet</p>
      )}
    </CardContent>
  </Card>
);
